import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { Security, LoginCallback } from "@okta/okta-react";
import { Route, Switch, withRouter, Redirect } from "react-router-dom";

import Root from "./Root";
import oktaAuth from "./config/okta";
import Users from "./containers/Users";
import { Paths } from "./constants/global";
import { BaseLayout } from "./components";
import { LO_STO, SESSION_STO } from "./util/constants";
import SecureRoute from "./components/BaseComponents/SecureRoute";
import { AuditLogs, Dashboard, Organizations, OrganizationDetail, Apikeys, Tokens } from "./containers";
import { initializeUser, isEmailVerified, logoutUser, startRefreshTimer } from "./api/auth";

const Routes = () => {
  let history = useHistory();

  // User loaded if both tockens and user data from Okta exists
  const [isUserLoaded, setIsUserLoaded] = useState(
    window.localStorage[LO_STO.OKTA_USER] &&
      window.localStorage[LO_STO.JWT_TOKEN] &&
      window.sessionStorage[SESSION_STO.SESSION_TOKEN]
  );

  const alwaysOnComponents = () => {
    startRefreshTimer();
  };

  const loadUser = async () => {
    await initializeUser(oktaAuth);
    setIsUserLoaded(true);
  };

  const validateUser = () => {
    if (!isUserLoaded) {
      loadUser();
      return null;
    }

    if (!isEmailVerified()) {
      logoutUser("Please verify your email.");
    }

    return alwaysOnComponents();
  };

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.push(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  useEffect(() => {
    const { pathname } = window.location;
    localStorage.setItem(LO_STO.CURRENT_PATH, pathname);
  }, []);

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {/* Authentication */}
      <Route exact path={Paths.BASE} component={Root} />

      {/* Always On Components */}
      <SecureRoute path="/:view" render={validateUser} />

      {isUserLoaded && (
        <BaseLayout>
          <Switch>
            <SecureRoute exact path={Paths.BASE} component={Tokens} />
            <SecureRoute exact path={Paths.TOKENS} component={Tokens} />
            <SecureRoute exact path={Paths.APIKEYS} component={Apikeys} />
            <SecureRoute exact path={Paths.USERS} component={Users} />
            <SecureRoute exact path={Paths.ANALYTICS} component={AuditLogs} />
            <SecureRoute exact path={Paths.DASHBOARD} component={Dashboard} />
            <SecureRoute exact path={Paths.ORGANIZATIONS} component={Organizations} />
            <SecureRoute path={Paths.ORGANIZATIONS + "/:orgId"} component={OrganizationDetail} />
            <Redirect to={Paths.DASHBOARD} />
          </Switch>
        </BaseLayout>
      )}
      <Route path={Paths.BASE} component={LoginCallback} />
    </Security>
  );
};
export default withRouter(Routes);
